import React from 'react'
import { Form, Divider, Button, Icon } from 'semantic-ui-react'
import Images from './images'

const details = ({obj, language, onChange, onDelete, onMoveService}) => {
  return (
    <div>
      {obj.services.map((service, index) => {
        return (
          <div key={index}>
            <div>
              {index !== 0 && <Button floated='left' size='mini' icon onClick={() => {onMoveService('up', index)}}><Icon name='arrow up' /></Button>}
              {obj.services.length - 1 !== index && <Button floated='left' size='mini' icon onClick={() => {onMoveService('down', index)}}><Icon name='arrow down' /></Button>}

              {obj.services.length !== 1 && <Button size='mini' floated='right' icon color='red' onClick={(e) => { onDelete(e, index) }}><Icon name="delete" /></Button>}
            </div>
            <Form.Field>
              <Form.Input placeholder='Nom du service' id='name' fluid label='Nom' value={service.translations[language.code].name} onChange={(e) => onChange(e, language.code, index)} />
            </Form.Field>
            <Form.Field>
              <Form.Group widths='equal'>
                <Form.Input placeholder='Label du bouton' id='cta_label' fluid label='Label du bouton' value={service.translations[language.code].cta_label} onChange={(e) => onChange(e, language.code, index)} />
                <Form.Input placeholder='https://...' id='cta_url' fluid label='Adresse cible' value={service.translations[language.code].cta_url} onChange={(e) => onChange(e, language.code, index)} />
              </Form.Group>
            </Form.Field>
            <Images obj={service} onChange={onChange} index={index} />

            {index !== obj.services.length - 1 && <Divider section />}
          </div>
        )
      })
      }
    </div>
  )
}

export default details



// WEBPACK FOOTER //
// ./src/components/form/pageBuilder/blocks/services/details.js